angular.module('ikeweb.spike').directive('compositeImage', ['spikeCaptureService',
    function(spikeCaptureService) {

        return {
            restrict: 'E',
            replace: true,
            scope: {
                capture: '=',
                scaled: '@'
            },
            link: function($scope, $element, $attrs) {

                $scope.$watch('capture', function() {
                    if (!$scope.capture) {
                        return;
                    }

                    $element.empty();
                    var capture = $scope.capture;

                    spikeCaptureService.getCaptureImage(capture, $attrs.scaled === 'y')
                        .then(function(image) {
                            $(image)
                                .addClass('CompositeImage-image')
                                .appendTo($element);

                            $element.append(capture.getMeasurementsSVG());
                        });
                });
            },
            template: '<div class="CompositeImage"></div>'
        };
    }
]);



//////////////////
// WEBPACK FOOTER
// ./src/client/components/spike/composite-image/composite.image.directive.js
// module id = 520
// module chunks = 0